/**
 * ✅ Migrated to authStore_v1 - 2026-01-07
 * 
 * Exchange secret key for JWT token
 * Simple mutation hook - actual success handling done in SalesforceCallback.tsx
 */
import { useMutation } from "@tanstack/react-query";
import { generateJwtFromSecretKey } from '@/services/salesforce/auth.graphql';
import toast from "react-hot-toast";

export function useExchangeSecretKey() {
  return useMutation({
    mutationFn: generateJwtFromSecretKey,
    onError: (error: any) => {
      console.error("❌ Secret key exchange failed:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Authentication failed";
      toast.error(errorMessage);
    },
    // Note: onSuccess is handled inline in SalesforceCallback.tsx
    // which overrides this mutation's onSuccess
  });
}
